import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrapper loading-skeleton"
}
const _hoisted_2 = { class: "inner-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "image-container"
}
const _hoisted_4 = { class: "inner-wrapper" }
const _hoisted_5 = {
  key: 0,
  class: "image-container"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 1,
  class: "placeholder-image rd-img-fluid"
}
const _hoisted_8 = { class: "content-container" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.loaded)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.showImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "placeholder-image" }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _cache[2] || (_cache[2] = _createElementVNode("section", { class: "content-container" }, [
            _createElementVNode("div", { class: "content" }, [
              _createElementVNode("div", {
                role: "status",
                class: "motion-safe:rd-pulse-slow rd-space-y-3"
              }, [
                _createElementVNode("div", { class: "rd-h-5 bg-neutral-4 rd-rounded-full rd-max-w-lg" }),
                _createElementVNode("section", { class: "rd-flex rd-items-center rd-w-full rd-mt-4" }, [
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-w-2/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-1/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-3/6" })
                ]),
                _createElementVNode("section", { class: "rd-flex rd-items-center rd-w-full rd-mt-1.5" }, [
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-w-3/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-ms-2.5 rd-w-2/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-1/6" })
                ]),
                _createElementVNode("section", { class: "rd-flex rd-items-center rd-w-full rd-mt-1.5" }, [
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-w-2/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-1/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-3/6" })
                ]),
                _createElementVNode("section", { class: "rd-flex rd-items-center rd-w-full rd-mt-1.5" }, [
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-w-3/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 bg-neutral-6 rd-rounded-full rd-ms-2.5 rd-w-2/6" }),
                  _createElementVNode("span", { class: "rd-h-3.5 rd-ms-2.5 bg-neutral-6 rd-rounded-full rd-w-1/6" })
                ]),
                _createElementVNode("span", { class: "rd-sr-only" }, "Loading...")
              ])
            ])
          ], -1))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["wrapper", { 'active': _ctx.renderStore.isProjectActive(_ctx.id) }])
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_Transition, { name: "fade-in-out" }, {
            default: _withCtx(() => [
              (_ctx.canRemove)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.remove && _ctx.remove(...args)), ["stop"])),
                    class: "rd-btn rd-btn-remove"
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                      "aria-hidden": "true"
                    }, [
                      _createElementVNode("path", { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z" })
                    ], -1),
                    _createElementVNode("span", { class: "rd-sr-only" }, "Remove project selection", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_ctx.showImage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.imageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.imageUrl,
                      class: "rd-img-fluid",
                      alt: `Image for ${_ctx.name} project`
                    }, null, 8, _hoisted_6))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", {
                class: _normalizeClass(["title", { 'rd-w-4/5': _ctx.canRemove }])
              }, _toDisplayString(_ctx.name), 3),
              (_ctx.hasDescription)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "text",
                    innerHTML: _ctx.description
                  }, null, 8, _hoisted_10))
                : _createCommentVNode("", true)
            ]),
            _renderSlot(_ctx.$slots, "projectGiftArray")
          ])
        ])
      ], 2))
}